// ============================================================
//  src/utils/helpers.js
//  Pure formatting + small utility functions. No React, no api.
// ============================================================

// ── Currency ────────────────────────────────────────────────
export function formatNaira(amount, showSymbol = true) {
  const n = Number(amount || 0);
  const s = n.toLocaleString('en-NG', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return showSymbol ? `₦${s}` : s;
}

// ── Dates ───────────────────────────────────────────────────
export function formatDate(dateStr, includeTime = false) {
  if (!dateStr) return '—';
  const d = new Date(dateStr.replace(' ', 'T'));
  if (isNaN(d.getTime())) return String(dateStr);
  const date = d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  if (!includeTime) return date;
  const time = d.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
  return `${date}, ${time}`;
}

export function timeAgo(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr.replace(' ', 'T'));
  const diff = Math.floor((Date.now() - d.getTime()) / 1000);
  if (isNaN(diff))         return '';
  if (diff < 30)           return 'just now';
  if (diff < 60)           return `${diff}s ago`;
  if (diff < 3600)         return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400)        return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 86400 * 7)    return `${Math.floor(diff / 86400)}d ago`;
  return formatDate(dateStr);
}

// ── Errors ──────────────────────────────────────────────────
export function getError(err) {
  return err?.response?.data?.message
      || err?.message
      || 'Something went wrong.';
}

// ── Strings ─────────────────────────────────────────────────
export function truncate(str, max = 40) {
  if (!str) return '';
  return str.length > max ? str.slice(0, max - 1) + '…' : str;
}

// ── Numbers ─────────────────────────────────────────────────
export function compact(n) {
  const x = Number(n || 0);
  if (x >= 1_000_000) return (x / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
  if (x >= 1_000)     return (x / 1_000).toFixed(1).replace(/\.0$/, '')    + 'k';
  return String(x);
}

// ── Misc ────────────────────────────────────────────────────
export function copyToClipboard(text) {
  if (navigator?.clipboard?.writeText) return navigator.clipboard.writeText(text);
  const ta = document.createElement('textarea');
  ta.value = text;
  document.body.appendChild(ta);
  ta.select();
  document.execCommand('copy');
  document.body.removeChild(ta);
  return Promise.resolve();
}
